<template>
  <div class="appt-state">
    <component
      v-if="editable"
      :is="popover ? 'el-popover' : 'div'"
      placement="bottom"
      :width="item.appt_confirmed ? 325 : 460"
      trigger="manual"
      v-model="isClicked"
    >
      <label slot="reference">
        <input
          type="checkbox"
          v-model="item.appt_confirmed"
          @change="isClicked = true"
          :disabled="isClicked"
        />
        <span v-html="text" />
      </label>
      <slot v-if="isClicked">
        <el-form v-if="!item.appt_confirmed" inline>
          <el-form-item>
            <el-select
              size="mini"
              v-model="reason"
              placeholder="- What reason to reschedule appointment? -"
              style="width: 320px"
            >
              <el-option
                v-for="(name, value) in reasons"
                :key="value"
                :label="name"
                :value="value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              size="mini"
              type="primary"
              class="narrow"
              @click="unconfirmAppt"
              :disabled="pendingReason"
              >Submit</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              size="mini"
              type="danger"
              class="narrow"
              @click="cancelUnconfirm"
              >Cancel</el-button
            >
          </el-form-item>
          <div class="hint red -mt-2">
            Appt. time will be removed automatically if Appt. is unconfirmed
          </div>
        </el-form>
      </slot>
    </component>
    <label v-else>
      <input
        type="checkbox"
        v-model="item.appt_confirmed"
        @click.stop
        :disabled="true"
      />
      <span v-html="text" />
    </label>
  </div>
</template>
<script>
import api from "@/default/utils/api";
export default {
  name: "ContainerApptConfirm",
  mixins: [api],
  props: {
    id: 0,
    text: "",
    confirmed: Boolean,
    editable: Boolean,
    reload: Boolean,
    popover: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isClicked: false,
      reasonForm: false,
      reason: null,
      item: {
        appt_confirmed: this.confirmed,
        appt_confirmed_editable: this.editable,
      },
    };
  },
  computed: {
    pendingReason() {
      return this.reason == null;
    },
    reasons() {
      const result = this.$store.apptReasons;
      if (result.length == 0) {
        this.loadApptReasons();
      }
      return this.$store.apptReasons;
    },
  },
  watch: {
    confirmed() {
      this.item.appt_confirmed = this.confirmed;
    },
    editable() {
      this.item.appt_confirmed_editable = this.editable;
    },
  },
  methods: {
    async unconfirmAppt() {
      try {
        const response = await this.$http.patch(
          `/api/v1/containers/${this.id}/appt`,
          {
            name: "unconfirm",
            reason: this.reason,
          },
        );
        this.isClicked = false;
        this.item = response.data;
        if (this.reload) Container.refresh(this.id);
        this.$emit("callback");
      } catch (err) {
        // Handle error silently as per original implementation
      }
    },
    cancelUnconfirm() {
      this.isClicked = false;
      this.item.appt_confirmed = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.appt-state {
  @apply flex items-center h-full w-full;
}
</style>
